export class DialogContent {

  allowClose: boolean = true;

  title?: string;
  message?: string;

}
